"use strict";
// Hot Module Replacement
function bootloader(main) {
    if (document.readyState === 'complete') {
        main();
    }
    else {
        document.addEventListener('DOMContentLoaded', main);
    }
}
exports.bootloader = bootloader;
// create new elements
function createNewHosts(cmps) {
    var components = cmps.map(function (componentNode) {
        var newNode = document.createElement(componentNode.tagName);
        // display none
        var currentDisplay = newNode.style.display;
        newNode.style.display = 'none';
        var parentNode = componentNode.parentNode;
        parentNode.insertBefore(newNode, componentNode);
        return { currentDisplay: currentDisplay, newNode: newNode };
    });
    return function () {
        components.forEach(function (cmp) {
            cmp.newNode.style.display = cmp.currentDisplay;
            cmp.newNode = null;
            cmp.currentDisplay = null;
        });
    };
}
exports.createNewHosts = createNewHosts;
// remove old styles
function removeNgStyles() {
    Array.prototype.slice.call(document.head.querySelectorAll('style'), 0)
        .filter(function (style) { return style.innerText.indexOf('_ng') !== -1; })
        .map(function (el) { return el.remove(); });
}
exports.removeNgStyles = removeNgStyles;
// get input values
function getInputValues() {
    var inputs = document.querySelectorAll('input');
    return Array.prototype.slice.call(inputs).map(function (input) { return input.value; });
}
exports.getInputValues = getInputValues;
// set input values
function setInputValues($inputs) {
    var inputs = document.querySelectorAll('input');
    if ($inputs && inputs.length === $inputs.length) {
        $inputs.forEach(function (value, i) {
            var el = inputs[i];
            el.value = value;
            el.dispatchEvent(new CustomEvent('input', { detail: el.value }));
        });
    }
}
exports.setInputValues = setInputValues;
// get/set input values
function createInputTransfer() {
    var $inputs = getInputValues();
    return function restoreInputValues() {
        setInputValues($inputs);
    };
}
exports.createInputTransfer = createInputTransfer;
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angularclass/hmr/dist/helpers.js
// module id = 429
// module chunks = 0